import {FilterConf} from '../../../../utils/GlobalSearch/types';
import {CONTENT_TYPE, FILTER_TYPES, TAG_TYPE} from '../../../../utils/GlobalSearch/enums';
import {fetchPlaceCategories, fetchTags} from '../../../../utils/GlobalSearch/fetchOptions';

const APARTMENT_CONFIG: {[CONTENT_TYPE.APARTMENT]: Record<string, FilterConf>} = {
  apartment: {
    studio: {
      key: 'studio',
      label: 'Studio',
      type: FILTER_TYPES.TOGGLE,
      quick: true,
    },
    "1_bedroom": {
      key: '1_bedroom',
      label: '1 Bedroom',
      type: FILTER_TYPES.TOGGLE,
      quick: true,
    },
    "2_bedroom": {
      key: '2_bedroom',
      label: '2 Bedroom',
      type: FILTER_TYPES.TOGGLE,
      quick: true,
    },
    "3+_bedroom": {
      key: '3+_bedroom',
      label: '3+ Bedroom',
      type: FILTER_TYPES.TOGGLE,
      quick: true,
    },
  },
};

export default APARTMENT_CONFIG;
